import { useState } from 'react';

export function useNow() {
  const [now] = useState(() => new Date());

  return now;
}
